import _ from 'lodash';
// eslint-disable-next-line import/prefer-default-export
export const lsModalService = {
    open({ parent, component, cancelable = true, ...props }) {
        // ops.lawnstarter uses a newer buefy, so check if $modal is present
        // in older buefy (used by my.), then adjust the path to .open if newer.
        let path;

        if (_.get(parent, '$modal')) {
            path = parent.$modal;
        } else {
            path = parent.$buefy.modal;
        }

        const appName = process.env.VUE_APP_NAME;
        // can be boolean or array https://buefy.org/documentation/modal
        const canCancel =
            appName === 'ops-lawnstarter' || !cancelable ? false : ['escape', 'outside'];

        path.open({
            parent,
            component,
            scroll: 'keep',
            width: 540,
            canCancel,
            ...props,
        });
    },
};
